import { useTabsContext } from '@app/app/_context/TabsContext/useTabsContext';
import { TabItem } from '@app/infrastructure/application/model/TabItem';
import { useMemo } from 'react';

export function TabsContent({ content, contentClassName }: { content: TabItem[]; contentClassName?: string }) {
    const { activeTabId } = useTabsContext();

    const activeContent = useMemo(() => content.find(item => item.id === activeTabId), [activeTabId, content]);

    return activeContent ? (
        <div className={contentClassName} key={activeContent.id} role="tabpanel" id={`tab-panel-${activeContent.id}`}>
            {activeContent.content}
        </div>
    ) : null;
}
